(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('nasrac-admin-customer-account', {
            parent: 'nasrac-admin',
            url: '/nasrac-admin-customer-account',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminCustomerAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-accounts.html',
                    controller: 'NasracAdminCustomerAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminCustomerAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('nasrac-admin-customer-account-detail', {
            parent: 'nasrac-admin-customer-account',
            url: '/nasrac-admin-customer-account/{id}',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminCustomerAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-detail.html',
                    controller: 'NasracAdminCustomerAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminCustomerAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NasracAdminCustomerAccount', function($stateParams, NasracAdminCustomerAccount) {
                    return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'nasrac-admin-customer-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('nasrac-admin-customer-account-detail.edit', {
            parent: 'nasrac-admin-customer-account-detail',
            url: '/detail/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-dialog.html',
                    controller: 'NasracAdminCustomerAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminCustomerAccount', function(NasracAdminCustomerAccount) {
                            return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-customer-account.new', {
            parent: 'nasrac-admin-customer-account',
            url: '/new',
            data: {
                authorities: roles,
                isReadOnly: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-dialog.html',
                    controller: 'NasracAdminCustomerAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                siteId: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                phone: null,
                                address: null,
                                city: null,
                                country: null,
                                state: null,
                                zipcode: null,
                                launchDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-customer-account', null, { reload: 'nasrac-admin-customer-account' });
                }, function() {
                    $state.go('nasrac-admin-customer-account');
                });
            }]
        })
        .state('nasrac-admin-customer-account.edit', {
            parent: 'nasrac-admin-customer-account',
            url: '/{id}/edit',
            data: {
                authorities: roles,
                isReadOnly: true

            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-dialog.html',
                    controller: 'NasracAdminCustomerAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminCustomerAccount', function(NasracAdminCustomerAccount) {
                            return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-customer-account', null, { reload: 'nasrac-admin-customer-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-customer-account.delete', {
            parent: 'nasrac-admin-customer-account',
            url: '/{id}/delete',
            data: {
                authorities: roles,
                isReadOnly: true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-delete-dialog.html',
                    controller: 'NasracAdminCustomerAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracAdminCustomerAccount', function(NasracAdminCustomerAccount) {
                            return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-customer-account', null, { reload: 'nasrac-admin-customer-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
